module.exports = __webpack_public_path__ + "static/IMG-2552-Original-b21e7eb9ef1145f8503843e4f5c02a2c.jpg";